/* eslint-disable class-methods-use-this, no-use-before-define, no-param-reassign, prefer-destructuring */
class ResourceList {
	constructor() {
		this.resourceList = document.getElementsByClassName("resource-list")[0];
		if (this.resourceList) {
			this.init();
		}
	}

	init() {
		const resourceListItemContents = this.resourceList.getElementsByClassName(
			"resource-list-item__content"
		);
		Array.prototype.forEach.call(
			resourceListItemContents,
			(resourceListItemContent) => {
				const children = resourceListItemContent.children;
				/* eslint-disable */
				for (let i = 0; i < children.length; i++) {
					const child = children[i];
					/* eslint-enable */
					if (child.tagName === "PRE") {
						if (
							child.firstChild.tagName === "IFRAME" ||
							child.firstChild.tagName === "IMG"
						) {
							child.firstChild.parentElement.classList.add("pre-fullWitdh");
							child.firstChild.parentElement.parentElement.parentElement.classList.add(
								"resource-list__list-item__pre-full-width"
							);
						}
					}
				}
			}
		);
	}
}

export default ResourceList;
